module.exports = __webpack_public_path__ + "img/unity.2cffd271.svg";